module.exports = __webpack_public_path__ + "static/media/howtoimg.dc2a0972.jpg";